
import { Form, Formik } from 'formik';
import React from 'react';
import * as Yup from 'yup';
import { TextFieldGroup } from 'shared/formik/TextFieldGroup';
import { MutationErrors } from '../../../shared/components/MutationErrors';
import { PageContainer } from 'shared/components/PageContainer';
import { RentalPageTitleHelmet } from 'rental/components/PageTitleHelmet';
import { SubmitActions } from '../../../shared/components/SubmitActions';
import { PageHeading } from 'shared/components/typography';
import { AltContactFragment, App_ApplicationFragment, useAltContactQuery, useUpdateCustomerMutation } from '../../generated.graphql';
import { getSubmitActionsProps } from 'shared/forms/helpers';
import { cleanPhoneNumber } from 'shared/utils/phone';
import { RentalStepProps } from 'rental/app/steps';
import { yupPhoneNumber } from '../../../shared/yup';


interface Props extends RentalStepProps {
  application: App_ApplicationFragment
}


export const AlternativeContact = (props: Props) => {
  const [result,] = useAltContactQuery({variables: {portalSlug: props.application.portal.slug}});
  const [, executeMutation] = useUpdateCustomerMutation();
  const customer = result.data?.portal?.myApplication?.customer;

  const formRef = React.useRef<any>();
  return (
    <div>
      <PageContainer>
        <RentalPageTitleHelmet>Alternative Contact</RentalPageTitleHelmet>
        <PageHeading className="h3" subtitle="In case we can't contact you, please provide an alternative contact.">Alternative Contact</PageHeading>

        {customer && 
          <Formik<AltContactFragment>
            initialValues={{
              altContactName: customer?.altContactName || '',
              altContactPhone: customer?.altContactPhone || '',
            }}
            validationSchema={
              Yup.object({
                altContactName: Yup.string().required('Required').min(3, 'Must be a full name with at least 3 characters'),
                altContactPhone: yupPhoneNumber.required('Required'),
              })
            }
            onSubmit={async (data, formikHelpers) => {
              const r = await executeMutation({
                input: {
                  ...data, 
                  portalSlug: props.application.portal.slug,
                  altContactPhone: cleanPhoneNumber(data.altContactPhone),
                }
              });
              formikHelpers.setStatus(r.data?.updateCustomer?.errors || null)
              if (r.data?.updateCustomer?.application) {
                props.onSubmitSuccessful()
              }
              else {
                props.onSubmitFailure()
              }
            }}
          >
            {formik => 
              <Form ref={formRef}>
                {formik.status && <MutationErrors errors={formik.status}/>}
                <div className="form-row">
                  <TextFieldGroup name="altContactName" className="col-md-6" label="Alternative contact's full name"/>
                  <TextFieldGroup name="altContactPhone" type="tel" className="col-md-6" label="Alternative contact's mobile number"/>
                </div>
                <SubmitActions {...getSubmitActionsProps(formik, props)}/>
              </Form>
            }
          </Formik>
        }

      </PageContainer>
    </div>
  )
}
